import React from 'react'
import estyled, { ecss } from '@signal/theme/emotion'
import { getSpacingSelector } from '@signal/theme/selectors'
import { CONSTRAINED_PAGE_MAX_WIDTH } from '../constants'
import { useMenuPanelWidth } from '../hooks'

const gutterSpacingSelector = getSpacingSelector(3)

export const StyledWrapper = estyled(
  ({
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    disableGutter,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    constrainWidth,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    $adjustPageContainerForMenu,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    menuPanelWidth,
    ...rest
  }) => <div {...rest} />
)`
  width: ${props =>
    props.$adjustPageContainerForMenu
      ? `calc(100% - ${props.menuPanelWidth})`
      : '100%'};
  /* Smooth transition to match sidebar animation timing */
  transition: ${props =>
    props.$adjustPageContainerForMenu ? 'width 0.3s ease-in-out' : 'none'};
  ${props =>
    props.constrainWidth && ecss`max-width: ${CONSTRAINED_PAGE_MAX_WIDTH};`}
  ${props =>
    !props.disableGutter && ecss`padding: 0 ${gutterSpacingSelector(props)}px;`}
`

// Wrapper component that uses the hook and passes the width as a prop
export const Wrapper = props => {
  const menuPanelWidth = useMenuPanelWidth()
  return <StyledWrapper {...props} menuPanelWidth={menuPanelWidth} />
}
